import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-file-manager-dialog-controller',
  templateUrl: './file-manager-dialog-controller.component.html',
  styleUrls: ['./file-manager-dialog-controller.component.scss']
})
export class FileManagerDialogControllerComponent {
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any) {}
}
